import {
  confirmProduct,
  issueResolved,
  LineDraft,
  matchFor,
  ReviewLine,
  rowHasQuestions,
  valuesFor,
} from './result-model'
import { conversionFor } from './unit-conversion'

export const lineReviewLabels = {
  name: 'Наименование',
  article: 'Артикул',
  unit: 'Единица',
  quantity: 'Количество',
  price: 'Цена',
  amount: 'Сумма',
  vat_rate: 'Ставка НДС',
  vat_amount: 'НДС',
  total: 'Сумма с НДС',
}

export function confirmedLineDraft(
  line: ReviewLine,
  draft: LineDraft,
  allowUnlinked: boolean,
): LineDraft {
  const chosen =
    !allowUnlinked && !matchFor(line, draft) && line.candidates?.length === 1
      ? { ...draft, match_index: 0 }
      : draft
  const selected = allowUnlinked ? draft : confirmProduct(line, { ...chosen, checked: false })
  const values = valuesFor(line, selected)
  const resolutions = { ...selected.resolutions }
  line.issues.forEach((issue, index) => {
    if (issue.field === 'match' || issueResolved(line, selected, index, allowUnlinked)) return
    const value = values[issue.field]
    if (value != null && String(value).trim())
      resolutions[index] =
        String(value) === String(line[issue.field] ?? '') ? 'accepted' : 'corrected'
  })
  return { ...selected, resolutions, checked: true }
}
export const lineDraftUnchanged = (current: LineDraft, next: LineDraft) => JSON.stringify(current) === JSON.stringify(next)

export function canConfirmLineDraft(
  line: ReviewLine,
  draft: LineDraft,
  allowUnlinked: boolean,
): boolean {
  const confirmed = confirmedLineDraft(line, draft, allowUnlinked)
  if (rowHasQuestions(line, confirmed, allowUnlinked)) return false
  const values = valuesFor(line, confirmed)
  for (const field of ['quantity', 'price', 'amount'] as const) {
    const value = Number(String(values[field] ?? '').replace(',', '.'))
    if (!Number.isFinite(value) || value < 0) return false
  }
  const match = matchFor(line, confirmed)
  return (
    allowUnlinked ||
    !match?.unit ||
    !!conversionFor(values.unit, match, confirmed.unit_confirmation)
  )
}

export function comparablePriceDifference(
  line: ReviewLine,
  draft: LineDraft,
  documentBasis?: LineDraft['amount_basis'],
): number | null {
  const selected =
    matchFor(line, draft) || (line.candidates?.length === 1 ? line.candidates[0] : undefined)
  const values = valuesFor(line, draft)
  const basis = values.amount_basis ?? documentBasis
  const conversion = conversionFor(values.unit, selected, draft.unit_confirmation)
  if (
    !selected ||
    !conversion ||
    conversion.factor !== 1 ||
    !['net', 'gross'].includes(basis || '') ||
    selected.amount_basis !== basis
  )
    return null
  const actual = Number(String(values.price ?? '').replace(',', '.')),
    expected = Number(String(selected.price ?? '').replace(',', '.'))
  return values.price != null &&
    selected.price != null &&
    Number.isFinite(actual) &&
    Number.isFinite(expected)
    ? actual - expected
    : null
}
